import { render, staticRenderFns } from "./Races.vue?vue&type=template&id=a6e6a8f2&scoped=true"
import script from "./Races.vue?vue&type=script&lang=js"
export * from "./Races.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e6a8f2",
  null
  
)

export default component.exports